import http from '../../core/services/http'

export const generateAdvancedProbeSessionReport = ({ sessionId }) =>
  http.get(`/reports/advanced-probe-session/${sessionId}`, {
    responseType: 'blob',
  })
